module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/e23uVX/tc-custom/9781504098915.jpg?1724535902033",
      "alt": "This image is the cover for the book Three of Us"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Three of Us\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A short-lived affair causes ripple effects through the years in this novel about the complexities of love and marriage by the author of "), _c('i', [_vm._v("A Part of Me")]), _vm._v(".")]), _c('br'), _c('br'), _c('i', [_vm._v("Molly loves Jack. But so does Carly . . .")]), _c('br'), _c('br'), _vm._v(" While working away from home, it’s easy for Jack to have a fling with Carly. Fiancée Molly will never find out; it’s not the first secret he’s kept from her."), _c('br'), _c('br'), _vm._v(" When the relationship runs its course, though, Carly can’t move on emotionally. For her, no man compares to Jack. Meanwhile, when Molly is ready to start a family, she’s disappointed to discover that Jack doesn’t share her dream, and she decides to turn her passion for baking into a business venture."), _c('br'), _c('br'), _vm._v(" Soon, fate brings the trio together again, impacting each of their lives. Can they finally be honest with each other—and with themselves—before all trust is lost?"), _c('br'), _c('br'), _c('b', [_vm._v("Praise for Vivien Brown")]), _c('br'), _c('br'), _vm._v(" “A truly gripping read.” —"), _c('i', [_vm._v("My Weekly")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Vivien Brown\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0